import React, { useState, useEffect } from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import { useCarrierAgreementReport } from "./hooks/useGetCarrierAgreementReport";
import useCarrierAgreementLinkAndCommision from "../ProducerCodeReports/hooks/useCarrierAgreementLinkAndCommision";
import SelectInput from "../../../../components/SelectInput";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useRecoilValue } from "recoil";
import { FunnelIcon, NewspaperIcon } from "@heroicons/react/24/solid";
import { useStates } from "../../hooks/useStates";
import SearchButton from "../../../../components/SearchButton";
import RefreshButton from "../../../../components/RefreshButton";
import { CSVLink } from "react-csv";
import { useDistinctEntity } from "./hooks/useGetDistinctEntity";
import DownloadButton from "../../../../components/DownloadButton";

export const CarrierAgreementReports = () => {
  const [carrierStateOfficeCodesData, setCarrierStateOfficeCodesData] =
    useState([]);
  const user = useRecoilValue(accountAtom);
  const [itemsFiltered, setItemsFiltered] = useState(0);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedState, setSelectedStates] = useState([]);
  const [selectedEntity, setSelectedEntity] = useState([]);
  const {
    data: carrierAgreement,
    isLoading: carrierAgreementLoading,
    isSuccess: carrierAgreementSuccess,
  } = useCarrierAgreementReport();
  const [hidePIFMax, sethidePIFMax] = useState(true);
  const [hidePIFMin, sethidePIFMin] = useState(true);
  const [hideOtherComTransaction, sethideComTransaction] = useState(true);
  const [hideOtherComPercentage, sethideComPercentage] = useState(true);
  const [searchInputsData, setSearchInputsData] = useState();
  const [enableSearch, setEnableSearch] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const {
    isSuccess: searchSuccess,
    data: searchResult,
    isFetching: searchLoading,
    refetch: searchRefetch,
  } = useCarrierAgreementLinkAndCommision({
    searchInputsData,
    enableSearch,
  });
  const getState = useStates();
  const [statesOpts, setStatesOpts] = useState([]);
  const getEntity = useDistinctEntity();
  const [entityOpts, setEntityOpts] = useState([]);
  const [exportedData, setExportedData] = useState([]);

  useEffect(() => {
    if (searchSuccess && searchResult && isFiltered) {
      if (searchResult.status === 200) {
        setCarrierStateOfficeCodesData(searchResult.data);
      } else {
        setCarrierStateOfficeCodesData([]);
      }
    }
  }, [searchSuccess, searchResult, isFiltered]);

  useEffect(() => {
    if (carrierAgreementSuccess && carrierAgreement && !isFiltered) {
      if (carrierAgreementSuccess === true) {
        setCarrierStateOfficeCodesData(carrierAgreement);
      } else {
        setCarrierStateOfficeCodesData([]);
      }
    }
  }, [carrierAgreementSuccess, carrierAgreement, isFiltered]);

  useEffect(() => {
    if (getState && getState.data) {
      setStatesOpts(
        getState.data.map((x) => {
          return { value: x.stateId, label: x.state };
        })
      );
    }
  }, [getState.data]);

  useEffect(() => {
    if (getEntity && getEntity.data) {
      setEntityOpts(
        getEntity?.data?.map((x) => {
          return {
            value: x.entityName,
            label: x.entityName,
          };
        })
      );
    }
  }, [getEntity.data]);

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();

  const downloadCampsReport = () => {
    if (carrierStateOfficeCodesData) {
      setExportedData(
        carrierStateOfficeCodesData.map(({ tableData, ...res }) => res)
      );
    }
  };
  const csvReport = {
    filename: "CAMSReports_" + dateTimeToday + ".csv",
    data: exportedData ? exportedData : [],
  };

  const filterOption = [
    { label: "No Source Link", value: 1 },
    { label: "No Commission", value: 2 },
  ];

  const [hasChange, setHasChange] = useState(false);
  const columns = [
    {
      title: "Carrier Name",
      field: "carrierName",
      render: (rowData) => {
        return <span className="text-sm">{rowData.carrierName}</span>;
      },
    },
    { title: "State", field: "state" },
    { title: "Agency", field: "agency" },
    { title: "Entity Name", field: "entity" },
    { title: "New Percentage", field: "newPercentage" },
    {
      title: "New Percentage Franchise",
      field: "newPercentageFranchise",
      hidden: !user.isFranchise,
    },
    {
      title: "New Percentage Confie",
      field: "newPercentageConfie",
      hidden: !user.isFranchise,
    },
    { title: "Renewal Percentage", field: "renewalPercentage" },
    {
      title: "Renewal Percentage Franchise",
      field: "renewPercentageFranchise",
      hidden: !user.isFranchise,
    },
    {
      title: "Renewal Percentage Confie",
      field: "renewPercentageConfie",
      hidden: !user.isFranchise,
    },
    { title: "Source Link", field: "sourcelink" },
    { title: "Policy Type", field: "policyType" },
    {
      title: "Expiration Date",
      field: "expirationDate",
      render: (rowData) => {
        return (
          <span className="text-sm">
            {rowData.expirationDate &&
              new Date(rowData.expirationDate).toLocaleDateString()}
          </span>
        );
      },
    },
    {
      title: "Effective Date",
      field: "effectiveDate",
      render: (rowData) => {
        return (
          <span className="text-sm">
            {rowData.effectiveDate &&
              new Date(rowData.effectiveDate).toLocaleDateString()}
          </span>
        );
      },
    },
    { title: "PIF Max", field: "pifMax", hidden: hidePIFMax },
    { title: "PIF Min", field: "pifMin", hidden: hidePIFMin },
    {
      title: "Other Commission Percentage",
      field: "otherCommissionPercentage",
      hidden: hideOtherComPercentage,
    },
    {
      title: "Other Commission Transaction",
      field: "otherCommissionTransaction",
      hidden: hideOtherComTransaction,
    },
  ];

  const hasValue = () => {
    return selectedEntity === undefined
      ? false
      : true || selectedState === undefined
      ? false
      : true || selectedOption === undefined
      ? false
      : true;
  };

  return (
    <div className="py-4 px-8 items-center">
      <div className="">
        <div className="overflow-x-auto">
          <div>
            <div className="flex gap-2 items-center">
              <div>
                <NewspaperIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">
                  Reports Module
                </h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  CARRIER AGREEMENTS REPORT
                </h1>
              </div>
            </div>
          </div>
          <div className="mt-2 " />
          <div className="flex justify-between">
            <div>
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {carrierStateOfficeCodesData?.length}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => {
                  downloadCampsReport();
                }}
                disabled={carrierAgreementLoading || searchLoading}
              />
            </CSVLink>
          </div>
        </div>
        <div className="mt-2 h-1 w-full border-b-2 border-secondary" />
        <div className="grid flex-row items-center my-4">
          <div className="">
            <div className="flex flex-row place-items-center text-xs bold gap-2">
              <div className="flex h-full text-sm"> Filter By </div>{" "}
              <FunnelIcon className="h-4 w-4 focus:bg-primary flex place-items-center" />{" "}
              <div
                style={{
                  top: "100px",
                  display: "fixed",
                  width: "150px",
                }}
              >
                <SelectInput
                  options={filterOption}
                  value={selectedOption}
                  onChange={(e) => {
                    setSearchInputsData({
                      ...searchInputsData,
                      searchId: e?.value,
                    });
                    setSelectedOption(e === null ? [] : e);
                    setHasChange(true);
                  }}
                  className={"z-99"}
                />
              </div>
              <div className="flex h-full text-sm">State </div>{" "}
              <div
                style={{
                  display: "fixed",
                  width: "150px",
                }}
              >
                <SelectInput
                  options={statesOpts}
                  value={selectedState}
                  onChange={(e) => {
                    setSearchInputsData({
                      ...searchInputsData,
                      state: e?.label,
                    });
                    setSelectedStates(e === null ? [] : e);
                    setHasChange(true);
                  }}
                />
              </div>
              <div className="flex h-full text-sm">Entity </div>{" "}
              <div
                style={{
                  display: "fixed",
                  width: "150px",
                }}
              >
                <SelectInput
                  options={entityOpts}
                  value={selectedEntity}
                  onChange={(e) => {
                    setSearchInputsData({
                      ...searchInputsData,
                      entityName: e?.value,
                    });
                    setSelectedEntity(e === null ? [] : e);
                    setHasChange(true);
                  }}
                />
              </div>
              <div>
                {" "}
                <SearchButton
                  buttonValue="Search"
                  className={hasChange ? "opacity-100 ml-2" : "opacity-50 ml-2"}
                  disabled={!hasChange}
                  onClick={() => {
                    searchRefetch();
                    setIsFiltered(true);
                  }}
                />
              </div>
              <div>
                <RefreshButton
                  className={hasChange ? "opacity-100" : "opacity-50"}
                  disabled={!hasChange}
                  onClick={() => {
                    setHasChange(false);
                    setSearchInputsData();
                    setIsFiltered(false);
                    setSelectedOption([]);
                    setSelectedStates([]);
                    setSelectedEntity([]);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto grid grid-row box-shadow">
          <MaterialTableTS
            data={carrierStateOfficeCodesData}
            isLoading={searchLoading ? searchLoading : carrierAgreementLoading}
            showTitle={false}
            search={false}
            exportButton={true}
            title="Overriding Export Function Preview"
            fileName={
              itemsFiltered == 1
                ? "Carrier Agreements with no Source link Report"
                : itemsFiltered == 2
                ? "Carrier Agreements with no Commission"
                : "Carrier Agreements"
            }
            columns={columns}
          />
        </div>
      </div>
    </div>
  );
};

export default CarrierAgreementReports;
